// src/context/RecruitmentContext.jsx
import React, { createContext, useContext } from "react";
import {
  useJobOpenings,
  useCandidates,
  useRecruitmentRequests,
  useInterviews,
  useOffers,
  useRecruitmentActivity,
  useReferrals,
} from "../hooks/useRecruitment";

const RecruitmentContext = createContext(null);

export function useRecruitmentContext() {
  const ctx = useContext(RecruitmentContext);
  if (!ctx) throw new Error("useRecruitmentContext must be used within a RecruitmentProvider");
  return ctx;
}

export const PIPELINE_STAGES = [
  "Applied",
  "Screening",
  "Assessment",
  "Interview",
  "Manager Review",
  "HR Review",
  "Offer",
  "Background Verification",
  "Onboarding",
  "Hired",
];

export const STAGE_COLORS = {
  Applied: "#1b4b31",
  Screening: "#1b4b31",
  Assessment: "#1b4b31",
  Interview: "#1b4b31",
  "Manager Review": "#1b4b31",
  "HR Review": "#1b4b31",
  Offer: "#1b4b31",
  "Background Verification": "#1b4b31",
  Onboarding: "#10b981",
  Hired: "#1b4b31",
  Rejected: "#486654",
  Withdrawn: "#6f8c79",
  Hold: "#486654",
};

export function RecruitmentProvider({ children }) {
  const { data: jobOpenings, loading: jobsLoading } = useJobOpenings();
  const { data: candidates, loading: candidatesLoading } = useCandidates();
  const { data: recruitmentRequests, loading: requestsLoading } = useRecruitmentRequests();
  const { data: interviews, loading: interviewsLoading } = useInterviews();
  const { data: offers, loading: offersLoading } = useOffers();
  const { data: activityLogs, loading: activityLoading } = useRecruitmentActivity();
  const { data: referrals, loading: referralsLoading } = useReferrals();

  const value = {
    jobOpenings,
    jobsLoading,
    candidates,
    candidatesLoading,
    recruitmentRequests,
    requestsLoading,
    interviews,
    interviewsLoading,
    offers,
    offersLoading,
    activityLogs,
    activityLoading,
    referrals,
    referralsLoading,
    stages: PIPELINE_STAGES,
    stageColors: STAGE_COLORS,
  };

  return (
    <RecruitmentContext.Provider value={value}>
      {children}
    </RecruitmentContext.Provider>
  );
}
